module.exports = __webpack_public_path__ + "img/PCT03.9c8f2ef3.svg";